module.exports = {
  pin: {
    sandbox: true,
    publishable_api_key: "pk_g8awWOlLWaGOxGDfksMA5w"
  },
  recaptcha: {
    site_key: "6LcenwEiAAAAAK8biCJI7pbwD3X6_AdnYz3u5y-G"
  },
};

/* 6LcenwEiAAAAAK8biCJI7pbwD3X6_AdnYz3u5y-G */
